// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".commutably {\n  --controls-row-gap: 0.6em;\n  --controls-row-justify-content: flex-start;\n}\n", "",{"version":3,"sources":["webpack://./src/theme/components/ControlsRow.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,0CAA0C;AAC5C","sourcesContent":[".commutably {\n  --controls-row-gap: 0.6em;\n  --controls-row-justify-content: flex-start;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
